import { memo } from 'react';
import Typography from '../Typography';
import { AO4, S1 } from '../../theme';
import Box from '../Box';

export interface ILabelProps {
    bgColor?: string;
    text: string;
}

interface IBuildSXParams {
    bgColor: string;
}

const buildSX = ({ bgColor }: IBuildSXParams) => ({
  background: bgColor,
  borderRadius: '8px 0px 8px 8px',
  padding: '4px 8px',
  display: 'inline-block',
});

const Label = (props: ILabelProps) => {
  const { bgColor = AO4, text } = props;

  return (
    <Box sx={buildSX({ bgColor })}>
      <Typography variant="caption" color={S1}>
        {text}
      </Typography>
    </Box>
  );
};

export default memo(Label);
